import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchWebTech,
  fetchWebTechGraph,
  fetchWebTotal,
  fetchWebTechAction,
} from "../../actions/sub-domain";
import "../../assets/css/recommendation-modal.css";
import { fetchCustomerDomains } from "../../actions/customer";
import Pagination from "../Pagination/Pagination";
import { Tooltip as ReactTooltip } from "react-tooltip";
import BasicLineColumn from "../common/apexChart/lineChart";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import PieChart from "../../components/common/dashboard12/piechart.js";
import Select from "@mui/material/Select";
import { Link, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import {API_URL} from "../../utils/constant";
import moment from "moment";

const WebTechnology = () => {
  let subdomains = useSelector(
    (state) => state?.subDomain?.response?.data?.domains
  );
  let totalData = useSelector((state) => state?.subDomain?.response?.data);

  let scanCompleted = useSelector((state) => state.subDomain?.scanCompleted);

  let scanDetails = useSelector(
    (state) => state?.subDomain?.garphData?.payload?.data
  );

  const vendorId = sessionStorage.getItem('vendorId');
  let totalCount = useSelector(
    (state) => state?.subDomain?.totalCount?.payload?.data
  );
  const [filterData, setfilterData] = useState("all");
  const [searchBy, setSearchBy] = useState("subDomainName");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [severity, setSeverity] = useState("");
  const [domain, setDomain] = useState("");
  
  const customerDomains = useSelector(
    (state) => state?.customer?.customerDomains?.data || []
  );

  subdomains = subdomains?.filter(
    (row) => row?.sslDetails?.[`${row?.subDomainName}`]?.cert_sn
  );

  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [minExploitabilityScore, setMinExploitabilityScore] = useState("");
  const [minExploitabilityScoreInput, setMinExploitabilityScoreInput] = useState("");
  const [scoreValidationError, setScoreValidationError] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [isModal, setModal] = useState("");
  const [name, setName] = useState("");
  const [isModalTwo, setModalTwo] = useState("");
  const [cve, setCve] = useState([]);
  const [category, setCategory] = useState("all");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [limit, setLimit] = useState(10);
  const vendorName = sessionStorage.getItem('vendorName');
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const myRef = useRef(null);
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const auth = useSelector((state) => state?.auth?.user);
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );


  // First useEffect for fetching total data
  useEffect(() => {
    fetchWebTotal(id, dispatch);
  }, [id, dispatch]);

  // Second useEffect for fetching tech graph
  useEffect(() => {
    fetchWebTechGraph(id, dispatch);
  }, [id, dispatch]);

  // Third useEffect for setting total items
  useEffect(() => {
    setTotalItems(totalData?.totalTechs);
  }, [totalData?.totalTechs]);  // Add these state variables to handle the date objects

  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add useEffect to fetch customer domains
  useEffect(() => {
    // Fetch domains for the current client/organization
    if (id) {
      dispatch(fetchCustomerDomains(id));
    }
  }, [id, dispatch]);
  
  // Fourth useEffect for fetching tech data
  useEffect(() => {
    if (orgId) {
      fetchWebTech(orgId, page, dispatch, category, filterData, searchBy, search, minExploitabilityScore, severity, startDate, endDate, limit, domain);
    } else {
      fetchWebTech(id, page, dispatch, category, filterData, searchBy, search, minExploitabilityScore, severity, startDate, endDate, limit, domain);
    }
  }, [id, page, dispatch, category, filterData, searchBy, search, category, minExploitabilityScore, severity, startDate, endDate, limit, domain]);

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event, name) => {
    if (event == "markAsRemediated") {
      const data = {
        action: "markAsRemediated",
        techIds: selectedIds == 0 ? _id : selectedIds,
        actionNote: "",
        for: "forever",
        techName: name,
      };
      fetchWebTechAction(
        id,
        page,
        dispatch,
        category,
        filterData,
        searchBy,
        search,
        data,
        domain
      );
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };

  const Unsnoozed = (_id) => {
    const data = {
      action: "resetAction",
      techIds: selectedIds == 0 ? _id : selectedIds,
    };
    fetchWebTechAction(
      id,
      page,
      dispatch,
      category,
      filterData,
      searchBy,
      search,
      data,
      domain
    );
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      techIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
      techName: name,
    };
    fetchWebTechAction(
      id,
      page,
      dispatch,
      category,
      filterData,
      searchBy,
      search,
      data,
      domain
    );
    setModalTwo("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const addModal = () => {
    setModalTwo("Form Wizard modal two");
  };

  let currentTableData = [];
  const subdomainsdData = useSelector(
    (state) => state?.subDomain?.response?.data?.technologies
  );

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/webtech_analysis/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Web Technology Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);
    clearTimeout(handleSearchChange.timeoutId);
    handleSearchChange.timeoutId = setTimeout(() => {
      setSearch(inputValue);
      setPage(1);
    }, 1000);
  };


  const handleSearchScore = (e) => {
    const inputValue = e.target.value;
    
    // Clear any existing error
    setScoreValidationError("");
    
    // Allow empty input
    if (inputValue === '') {
      setMinExploitabilityScoreInput(inputValue);
      clearTimeout(handleSearchScore.timeoutId);
      handleSearchScore.timeoutId = setTimeout(() => {
        setMinExploitabilityScore(inputValue);
        setPage(1);
      }, 1000);
      return;
    }
    
    const numValue = parseFloat(inputValue);
    
    // Validate input: only allow numbers between 0 and 10
    if (isNaN(numValue) || numValue < 0 || numValue > 10) {
      setScoreValidationError("Please enter a value between 0 and 10");
      return;
    }
    
    setMinExploitabilityScoreInput(inputValue);
    clearTimeout(handleSearchScore.timeoutId);
    handleSearchScore.timeoutId = setTimeout(() => {
      setMinExploitabilityScore(inputValue);
      setPage(1);
    }, 1000);
  };


  const outdatedTechPercent =
    ((totalCount?.totalOutdatedTechs || 0) /
      (totalCount?.totalUsedUniqueTechs + totalCount?.totalOutdatedTechs ||
        0)) *
    100;
  const latesTechPercent =
    ((totalCount?.totalUsedUniqueTechs || 0) /
      (totalCount?.totalUsedUniqueTechs + totalCount?.totalOutdatedTechs ||
        0)) *
    100;
  let mapData = subdomainsdData;

  mapData = mapData;

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }


  // Tooltip rebuild is no longer needed in react-tooltip v5+

  const editModal = (row) => {
    setCve(row);
    setModal("Form Wizard modal");
  };

  const series = [
    totalCount?.totalUsedUniqueTechs || 0,
    totalCount?.totalVulnerableSubdomains || 0
  ];

  const labels = ["Web Technologies", "Vulnerable Subdomains"];
  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
                                <ReactTooltip className="reactTooltipClass" />
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Outdated Web Technologies </h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{ color: "white" }}
                  >
                    Outdated Web Technologies
                  </li>
                </ol>
                <br />
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
             <span>
               <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
              </span>
              {mapData?.length === 0 ? null : (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <div className="row clearfix">
          <div className="col-lg-4 col-md-12">
            <div className="card RecordFoundCard">
              <div className="body" style={{ minHeight: "440px" }}>
                <h6 className="mb-4">Records Found</h6>
                <div className="d-flex mb-4 justify-content-center">
                  {series && series?.length > 0 && <PieChart series={series} label={labels} />}
                </div>

                <div className="form-group">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("webTechs")}
                  >
                    <span className="greenShadow"></span>
                    Web Technologies
                    <span className="float-right">
                      {totalCount?.totalUsedUniqueTechs || 0}
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-warning"
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{}}
                    ></div>
                  </div>
                </div>

                <div className="form-group">
                  <label
                    className="d-block"
                    style={{ cursor: "pointer" }}
                    onClick={() => setfilterData("vulnerable")}
                  >
                    <span className="yellowShadow"></span>
                    Vulnerable Subdomains
                    <span className="float-right">
                      {totalCount?.totalVulnerableSubdomains || 0}
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-warning"
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{}}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-12">
            <div className="card user_statistics">
              <div
                className="body"
                id="graphBody"
                style={{ minHeight: "440px" }}
              >
                <h6 className="welcome-textSmall">Previous scan details</h6>

                {scanDetails && (
                  <BasicLineColumn
                    dates={scanDetails?.dates}
                    ipArray={scanDetails?.scanDetails}
                    color={["#08283f"]}
                    yAxis="Records Found"
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                  <li className="nav-item">
                    <a
                      className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("all");
                        setPage(1);
                        setfilterData("all");
                        setSearchBy("subDomainName");
                        setSearch("");
                        setSearchInput("");
                        setSelectedIds([]);
                        setSeverity('');
                        setMinExploitabilityScore('');
                        setMinExploitabilityScoreInput('');
                        setScoreValidationError('');
                      }}
                    >
                      Current
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("risk-accepted");
                        setPage(1);
                        setfilterData("all");
                        setSearchBy("subDomainName");
                        setSearch("");
                        setSearchInput("");
                        setSelectedIds([]);
                        setSeverity('');
                        setMinExploitabilityScore('');
                        setMinExploitabilityScoreInput('');
                        setScoreValidationError('');
                      }}
                    >
                      Risk Accepted
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("false-positive");
                        setPage(1);
                        setfilterData("all");
                        setSearchBy("subDomainName");
                        setSearch("");
                        setSearchInput("");
                        setSelectedIds([]);
                        setSeverity('');
                        setMinExploitabilityScore('');
                        setMinExploitabilityScoreInput('');
                        setScoreValidationError('');
                      }}
                    >
                      False Positive
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("remidiated");
                        setPage(1);
                        setfilterData("all");
                        setSearchBy("subDomainName");
                        setSearch("");
                        setSearchInput("");
                        setSelectedIds([]);
                        setSeverity('');
                        setMinExploitabilityScore('');
                        setMinExploitabilityScoreInput('');
                        setScoreValidationError('');
                      }}
                    >
                      Remediated
                    </a>
                  </li>
                </ul>
                <div className="card card_tableBox" ref={myRef}>
                  <div className="header">
                    <div className="body">
                      <div className="row">
                        <div className="col-sm-3 mb-2">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            value={filterData}
                            onChange={(e) => {
                              setfilterData(e.target.value);
                              setPage(1);
                            }}
                          >
                            <option value="all">All</option>
                            <option value="Vulnerable">Vulnerable</option>
                            <option value="OK">Not Vulnerable</option>
                          </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            value={searchBy}
                            onChange={(e) => {
                              setSearchBy(e.target.value);
                              setPage(1);
                            }}
                          >
                            <option value="subDomainName">Sub Domain</option>
                            <option value="techStack">Tech Stack</option>
                          </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            value={severity}
                            onChange={(e) => {
                              setSeverity(e.target.value);
                              setPage(1);
                            }}
                          >
                            <option value="">Severity</option>
                            <option value="HIGH">High</option>
                            <option value="MEDIUM">Medium</option>
                            <option value="LOW">Low</option>
                          </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            placeholder="Select Domain"
                            value={domain}
                            onChange={(e) => {
                              setDomain(e.target.value);
                              setPage(1);
                            }}
                          >
                            <option value="">All Domains</option>
                            {customerDomains?.domains?.map((domainItem, index) => (
                              <option key={index} value={domainItem}>
                                {domainItem}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <div
                            className="searchBoxInput p-0"
                          >
                            <input
                              class="form-control form-control-sm ml-0 my-1"
                              type="text"
                              placeholder={searchBy === "subDomainName" ? "Search Sub Domain" : "Search Tech Stack"}
                              aria-label="Search"
                              value={searchInput}
                              onChange={handleSearchChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div
                            data-test="datatable-input"
                            class="mdb-datatable-filter flex-row"
                          >
                            <input
                              class={`form-control form-control-sm ml-0 my-1 ${scoreValidationError ? 'is-invalid' : ''}`}
                              type="number"
                              min="0"
                              max="10"
                              step="0.1"
                              placeholder="Exploitability Score (0-10)"
                              value={minExploitabilityScoreInput}
                              onChange={handleSearchScore}
                              title="Enter a value between 0 and 10"
                            />
                            {scoreValidationError && (
                              <div className="invalid-feedback d-block" style={{ fontSize: '12px', color: '#dc3545' }}>
                                {scoreValidationError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <div className="date-picker-container">
                            <div className="date-range-input">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Select date range"
                                value={formatDateRange()}
                                onClick={() => setDatePickerOpen(true)}
                                readOnly
                              />
                              <span className="calendar-icon">
                                <i className="fa fa-calendar" aria-hidden="true"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          {selectedIds?.length > 1 && userPermission && category === "all" && (
                            <Box sx={{ width: 160 }}>
                              <FormControl fullWidth>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={selectedValue}
                                  onChange={(event) => {
                                    setAction(event.target.value);
                                    snooze("", event.target.value);
                                  }}
                                >
                                  <MenuItem value="pleaseSelect">
                                    Snooze Options
                                  </MenuItem>
                                  <MenuItem
                                    value="riskAccepted"
                                    onClick={() => {
                                      addModal();
                                    }}
                                  >
                                    Risk Accepted
                                  </MenuItem>
                                  <MenuItem
                                    value="markAsFalsePositive"
                                    onClick={() => {
                                      addModal();
                                    }}
                                  >
                                    False Positive
                                  </MenuItem>
                                  <MenuItem value="markAsRemediated">
                                    Remediated
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          )}
                          {selectedIds?.length > 1 &&
                            (category == "false-positive" ||
                              category == "risk-accepted") && userPermission && (
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                onClick={() => Unsnoozed("")}
                              >
                                Unsnooze
                              </button>
                            )}
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-custom spacing5 mb-0">
                          <thead>
                            <tr>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th>
                                    <input
                                      type="checkbox"
                                      checked={
                                        selectedIds == 0 ? false : multiCheckTrue
                                      }
                                      onClick={() => {
                                        multicheck(currentTableData);
                                      }}
                                      className="checkUncheck"
                                    />
                                  </th>
                                )}
                              <th>Status</th>
                              <th>Sub Domain</th>
                              <th>Tech Stack</th>
                              <th>Current Version</th>
                              <th>Latest Version</th>
                              <th>Cves Detail</th>
                              <th>Exploitable</th>
                              <th>Created At</th>
                              <th>Updated At</th>
                              {category !== "all" && <th style={{width: 120}}>Action Note</th>}
                              <th>Severity</th>
                              {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th style={{ width: "80" }}>Action</th>
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {currentTableData?.map((res, index) => {
                              return (
                                <tr key={index}>
                                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                    category === "risk-accepted" ||
                                    category === "false-positive") && (
                                      <td>
                                        <input
                                          onClick={() =>
                                            singleClick(
                                              res?._id
                                            )
                                          }
                                          checked={selectedIds?.includes(res?._id)}
                                          type="checkbox"
                                          className="checkUncheck"
                                        />
                                      </td>
                                    )}
                                  <td>
                                    {res?.hasVulnerabilities ? (
                                      res?.exploits && Object.values(res?.exploits).some(
                                        (exploit) => exploit?.length > 0
                                      ) ? (
                                        <span className="badge badge-dark" style={{backgroundColor:"#dc2b2b"}}>
                                          Exploitable
                                        </span>
                                      ) : (
                                        <span className="badge badge-dark" style={{backgroundColor:"#ff6f6f"}}>
                                          Vulnerable
                                        </span>
                                      )
                                    ) : (
                                      <span className="badge badge-success">
                                        Not Vulnerable
                                      </span>
                                    )}
                                  </td>
                                  <td id="info">{res?.subDomainName}</td>
                                  <td>{res?.name}</td>
                                  <td>{res?.version}</td>
                                  <td>{res?.latestVersion}</td>
                                  <td
                                    onClick={() =>
                                      res?.cvesInfo?.length !== 0 &&
                                      editModal(res?.cvesInfo)
                                    }
                                    style={{
                                      cursor:
                                        res?.cvesInfo?.length !== 0
                                          ? "pointer"
                                          : "auto",
                                    }}
                                  >
                                    {res?.cvesInfo?.length !== 0
                                      ? <Link to="#">Vulnerable (Detail)</Link> : "N/A"}
                                  </td>
                                  {/* <td
                                    onClick={() =>
                                      Object.keys(res?.exploits || {}).length !== 0 &&
                                      editModal(res)
                                    }
                                    style={{
                                      cursor:
                                        Object.keys(res?.exploits || {}).length !== 0
                                          ? "pointer"
                                          : "auto",
                                    }}
                                  >
                                    {Object.keys(res?.exploits || {}).length !== 0
                                      ? "Vulnerable (Detail)"
                                      : "N/A"}
                                  </td> */}
                                  {/* <td>
                                    {res?.cvesInfo?.some(
                                      (exploit) => exploit?.knownExploits?.length > 0
                                    )
                                      ? "Yes"
                                      : "No"}
                                  </td> */}
                                  <td>
                                    {Array?.isArray(res?.cvesInfo) && res?.cvesInfo?.some(
                                      (exploit) => Array?.isArray(exploit?.knownExploits) && exploit?.knownExploits?.length > 0
                                    )
                                      ? "Yes"
                                      : "No"}
                                  </td>
                                  <td>
                                    {moment(res?.createdAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                  <td>
                                    {moment(res?.updatedAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                  {category !== "all" && <td style={{ whiteSpace: "unset" }}>{res?.actionNote ? res.actionNote : "N/A"}</td>}
                                  <td>
                                    {res?.highestSeverity == "HIGH" && (
                                      <span className="badge bg-danger" style={{ color: "black" }}>High</span>
                                    )}
                                    {res?.highestSeverity == "MEDIUM" && (
                                      <span className="badge bg-warning" style={{ color: "black" }}>Medium</span>
                                    )}
                                    {res?.highestSeverity == "LOW" && (
                                      <span className="badge bg-success" style={{ color: "black" }}>Low</span>
                                    )}
                                    {res?.highestSeverity == null && (
                                      <span style={{ color: "black" }}>N/A</span>
                                    )}
                                  </td>
                                  {/* <td
                                    onClick={() =>
                                      res?.exploits &&
                                      Object?.keys(res?.exploits)?.length > 0 &&
                                      editModal(res)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {Object?.keys(res?.exploits)?.length === 0
                                      ? "N/A"
                                      : "Vulnerable (Detail)"}
                                  </td>
                                  <td>
                                    {res?.exploits &&
                                    Object.values(res?.exploits).some(
                                      (exploit) => exploit?.length > 0
                                    )
                                      ? "Yes"
                                      : "No"}
                                  </td> */}
                                  {res?.isRemediationPending == true ? <td>Retest in progress</td> : <>
                                    {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                      <td>
                                        <Box sx={{ width: 160 }}>
                                          <FormControl fullWidth>
                                            <Select
                                              labelId="demo-simple-select-label"
                                              id="demo-simple-select"
                                              value={selectedValue}
                                              onChange={(event) => {
                                                setAction(event.target.value);
                                                snooze(
                                                  res?._id,
                                                  event.target.value,
                                                  res?.name
                                                );
                                              }}
                                            >
                                              <MenuItem value="pleaseSelect">
                                                Snooze Options
                                              </MenuItem>
                                              <MenuItem
                                                value="riskAccepted"
                                                onClick={() => {
                                                  addModal();
                                                  setName(res?.name);
                                                  setLookalikeAppId([res?._id]);
                                                }}
                                              >
                                                Risk Accepted
                                              </MenuItem>
                                              <MenuItem
                                                value="markAsFalsePositive"
                                                onClick={() => {
                                                  addModal();
                                                  setName(res?.name);
                                                  setLookalikeAppId([res?._id]);
                                                }}
                                              >
                                                False Positive
                                              </MenuItem>
                                              <MenuItem value="markAsRemediated">
                                                Remediated
                                              </MenuItem>
                                            </Select>
                                          </FormControl>
                                        </Box>
                                      </td>
                                    )}
                                  </>
                                  }
                                  {auth?.accessLevel != "Threat Analyst" && (category === "risk-accepted" ||
                                    category === "false-positive") && (
                                      <td>
                                        <button
                                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                          onClick={() =>
                                            Unsnoozed(
                                              res?._id,
                                              res?.name,
                                              res?.uuid
                                            )
                                          }
                                        >
                                          Unsnooze
                                        </button>
                                      </td>
                                    )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-between align-content-center">
                        <div className="dataTables_paginate">
                          {totalItems > 0 && (
                            <Pagination
                              className="pagination-bar"
                              currentPage={page}
                              totalCount={totalItems}
                              pageSize={limit}
                              onPageChange={(page) => {
                                setPage(page);
                              }}
                            />
                          )}
                        </div>
                        {totalItems > 10 && (
                          <select
                            value={limit}
                            onChange={(e) => {
                              setLimit(e.target.value)
                            }}
                            className="form-control limitSelectBox"
                          >
                            <option value={10}>10 per page</option>
                            <option value={25}>25 per page</option>
                            <option value={50}>50 per page</option>
                            <option value={100}>100 per page</option>
                          </select>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Cve Details
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setModal("")}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                        <table className="table table-custom spacing5 mb-0">
                          <thead>
                            <tr>
                              <th>CVE ID</th>
                              <th>Known Exploit</th>
                              <th>Severity</th>
                            </tr>
                          </thead>
                          {cve && (
                            <tbody>
                              {cve.map((r) => (
                                <tr key={r.cveId}>
                                  <td>
                                    <strong>
                                      <Link
                                        to={`/cve/${r.cveId}`}
                                        className="p-2 rounded-md bg-slate-200"
                                      >
                                        {r.cveId || "N/A"}
                                      </Link>
                                    </strong>
                                  </td>
                                  <td>
                                    <ul className="m-0">
                                      {r.knownExploits && r.knownExploits.length > 0 ? (
                                        r.knownExploits.map((link, index) => (
                                          <li className="m-0" key={index}>
                                            <a
                                              href={link}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {link || "N/A"}
                                            </a>
                                          </li>
                                        ))
                                      ) : (
                                        <li className="m-0">N/A</li>
                                      )}
                                    </ul>
                                  </td>
                                  <td>
                                    {r.severity || "N/A"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
                 {/* Move date picker outside of the component tree to ensure proper rendering */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
        <div
          className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalTwo("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModalTwo("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek identifies outdated and vulnerable web technologies by continuously
                  profiling public-facing subdomains, frameworks, libraries, servers, and cloud
                  components and comparing detected versions against known vulnerabilities,
                  CVE databases, and exploit intelligence.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Are Outdated & Vulnerable Web Technologies</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Outdated web technologies are frameworks, libraries, web servers, or platforms
                      running versions that are no longer supported or contain known security
                      vulnerabilities. These weaknesses are frequently targeted by automated scanners,
                      botnets, and exploit kits.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What BrandSek Detects</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Client-side frameworks (AngularJS, jQuery, React, etc.)</li>
                      <li>Web servers and middleware (Nginx, Apache, IIS)</li>
                      <li>Cloud and CDN exposed components</li>
                      <li>Current version vs latest secure version</li>
                      <li>Mapped CVEs and exploitability indicators</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Key Risks Observed</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Remote code execution and privilege escalation</li>
                      <li>Authentication bypass and access control flaws</li>
                      <li>Cross-site scripting (XSS) and injection attacks</li>
                      <li>Public exploit availability for known CVEs</li>
                      <li>Chaining vulnerabilities with open ports or misconfigurations</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Business & Compliance Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Exploitable technologies significantly increase breach likelihood and may
                      violate ISO 27001 secure configuration controls, CERT-In advisories, and customer
                      security expectations. Attackers often prioritize outdated components due to
                      low effort and high success rates.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Technology & Version Validation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Validate detected technology and version accuracy</li>
                      <li>Confirm asset ownership and exposure scope</li>
                      <li>Identify production vs non-production usage</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.9 · Asset Management</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Vulnerability & Exploit Assessment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Review mapped CVEs and exploit references</li>
                      <li>Check exploitability status (public exploits available)</li>
                      <li>Prioritize internet-facing and exploitable findings</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.8 · Threat Intelligence</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Upgrade & Remediation Actions</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Upgrade to latest secure and supported versions</li>
                      <li>Apply vendor security patches</li>
                      <li>Remove unused or deprecated components</li>
                    </ul>
                    <div className="compliance-tag">CERT-In · Secure Configuration</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Risk Acceptance & Continuous Monitoring</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Document risk acceptance where upgrades are constrained</li>
                      <li>Monitor for new CVEs and version drift</li>
                      <li>Revalidate after remediation or deployment changes</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Risk Treatment</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WebTechnology;
